export default class SegmentLog {
	constructor({
		id,
		contact,
		segment,
		query,
		direction,
		date
	} = {}) {
		this._id = id;
		this._contact = contact || null;
		this._segment = segment || null;
		this._query = query || '';
		this._direction = direction;
		this._date = date;
	}

	getId() {
		return this._id;
	}

	getKey() {
		return String(this._id);
	}

	getContact() {
		return this._contact;
	}

	getSegment() {
		return this._segment;
	}

	getQuery() {
		return this._query;
	}

	getDirection() {
		return this._direction;
	}

	getDate() {
		return this._date;
	}

	getLink() {
		if (this._query) {
			return `/contacts?${this._query}`;
		}
		if (this._segment) {
			return `/segments/${this._segment.id}`;
		}
		if (this._contact) {
			return `/contacts/${this._contact.id}`;
		}
		return '#';
	}

	toString() {
		if (this._query) {
			return this._query;
		}
		if (this._segment) {
			return this._segment.name;
		}
		if (this._contact) {
			if (this._contact.infos) {
				const { first_name: firstName='', last_name: lastName=''} = this._contact.infos;
				return `${firstName.slice(0, 1).toUpperCase()}${firstName.slice(1).toLowerCase()} ${lastName.toUpperCase()}`;
			}
			if (this._contact.email) {
				return `${this._contact.email.email}`;
			}
			return `Contact ${this._contact.id}`;
		}
		return '?';
	}
}
